
<div class="dls-page-scroll-wrapper d-flex flex-column" *ngIf="elemHeights.length">
  <label> Contents </label>
  <!-- Right side navigation list -->
  <ul>
    <!-- Right side navigation list-item -->
    <li 
      *ngFor="let navItem of navigationItems | async; index as navItemIndex" 
      [ngClass]="{'active-item': currentSection == navItemIndex}"
      >
        <a (click)="navSelected(navItem)" 
          [ngClass]="{'ms-0': navItem.indentIndex == 1, 'ms-3': navItem.indentIndex == 2}"
          title="{{navItem.id}}"
          >
          {{navItem.title}}
        </a>
    </li>
  </ul>
</div>